import {
  ApiConstants,
  ApplicationConstants,
  OverlaysConstants
} from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface CompanyState {
  companyAlreadyExists: boolean;
  showModal: boolean;
  lastCompanyInformation: Record<string, any>;
  noPersistance: boolean;
}

export const getInitialState = (): CompanyState => ({
  companyAlreadyExists: false,
  showModal: false,
  lastCompanyInformation: {},
  noPersistance: true
});

export default createReducer(getInitialState, {
  [`${ApiConstants.CHECK_IF_COMPANY_EXISTS}_SUCCESS`]: (
    state: CompanyState,
    { companyAlreadyExists, lastCompanyInformation }
  ) => ({
    ...state,
    companyAlreadyExists: companyAlreadyExists || false,
    lastCompanyInformation: lastCompanyInformation || {},
    showModal: !!companyAlreadyExists
  }),
  [`${ApiConstants.CHECK_IF_COMPANY_EXISTS}_FAILURE`]: (
    state: CompanyState
  ) => ({
    ...state,
    companyAlreadyExists: false,
    showModal: false,
    lastCompanyInformation: {}
  }),
  [`${OverlaysConstants.CLOSE_COMPANY_EXISTS_MODAL}`]: (
    state: CompanyState
  ) => ({
    ...state,
    companyAlreadyExists: true,
    showModal: false
  }),
  [`${ApplicationConstants.CLEAN_COMPANY_EXISTS_INFO}`]: (
    state: CompanyState
  ) => ({
    ...state,
    companyAlreadyExists: false,
    showModal: false,
    lastCompanyInformation: {}
  })
});
